<template>
  <div class="aBitOfMargin"> <!-- navMargin -->
    <NavBar :transparent-on-top="true"></NavBar>
    <div v-if="!isLoggedIn">
      <h1>No has iniciado sesión</h1>
    </div>
    <div v-if="isLoggedIn">
      <!-- <div class="aBitOfMargin">
        <vs-button @click="sidebar.activeSidebar = !sidebar.activeSidebar" flat icon>
          <i class='bx bx-menu'></i>
        </vs-button>
      </div> -->
      <vs-button @click="sidebar.activeSidebar = !sidebar.activeSidebar" flat icon style="position: absolute; left: 5px; top: 100px">
        <i class='bx bx-menu'></i>
      </vs-button>
      <!-- -->
      <vs-row justify="center">
        <vs-col v-if="sidebar.active === 'home'" lg="9" xs="12" w="9" style="background-color: #313131; border-radius: 10px 10px; padding: 20px; min-height: 400px">
          <div style="text-align: center;"><h2>Ajustes</h2></div>

          <vs-row>
            <vs-col w="6" style="text-align: center">
              <!-- <img src="https://cdn.discordapp.com/attachments/324659851911364608/948821411512848384/940692677131923487.png" width="300" alt="Tu avatar"> -->
              <img :src="$store.state.auth.avatarURL" width="300" alt="Tu avatar">
              <div>Tu avatar</div>
            </vs-col>
            <vs-col w="6">
              <vs-alert warn v-if="account.verifiedEmail">
                <template #icon>
                  <i class="bx bx-error"></i>
                </template>
                No has verificado tu correo electrónico
              </vs-alert>
              <div class="user-option">
                <b>Nombre de usuario</b>
                <vs-input v-model="options.realname"></vs-input>
              </div>
              <div class="user-option">
                <b>Correo electrónico</b>
                <vs-input v-model="options.email"></vs-input>
              </div>
              <div class="user-option">
                <b>Género</b>
                <vs-radio v-model="options.gender" val="male" class="radio-left">
                  Masculino
                </vs-radio>
                <vs-radio v-model="options.gender" val="female" class="radio-left">
                  Femenino
                </vs-radio>
                <vs-radio v-model="options.gender" val="attack_helicopter" class="radio-left">
                  Helicóptero Apache de ataque AH-64
                </vs-radio>
                <vs-radio v-model="options.gender" val="none" class="radio-left">
                  Prefiero no decirlo
                </vs-radio>
              </div>
              <div class="user-option">
                <b>Avatar</b>
                <vs-radio v-model="options.avatarType" val="gravatar" class="radio-left">
                  Gravatar
                </vs-radio>
                <vs-radio disabled v-model="options.avatarType" val="discord" class="radio-left">
                  Discord
                </vs-radio>
                <vs-radio v-model="options.avatarType" val="minecraft" class="radio-left">
                  Minecraft
                </vs-radio>
              </div>
              <div class="user-option">
                <b>Privacidad</b>
                <vs-row>
                  <vs-col w="2">
                    <vs-switch v-model="options.publicProfile" class="radio-left">
                      <template #off> Privado </template>
                      <template #on> Público </template>
                    </vs-switch>
                  </vs-col>
                  <vs-col w="10" style="padding-left: 10px">
                    Mostrar mi perfil a los demás
                  </vs-col>
                </vs-row>
              </div>
              <div style="display: flex;align-items: center;justify-content: center" @click="saveChanges">
                <vs-button primary>Guardar</vs-button>
              </div>
            </vs-col>
          </vs-row>
        </vs-col>

        <!-- <vs-col v-if="sidebar.active === 'subscription'" lg="9" xs="12" w="9" style="background-color: #313131; border-radius: 10px 10px; padding: 20px; min-height: 400px">
          <div style="text-align: center;"><h2>Suscripción</h2></div>
          <b>Tu suscripción</b>
          Actualmente eres un usuario.

          <b>Próxima renovación</b>
          Actualmente eres un usuario.

          <b>Suscribirse mediante PayPal</b>
          <div id="container-paypal"></div>
        </vs-col> -->
      </vs-row>
    </div>

    <vs-sidebar
        v-model="sidebar.active"
        :open.sync="sidebar.activeSidebar"
        @input="loadPayPalButton"
    >
      <template #logo>
        <img src="../assets/logo_white.png" alt="Logo">
      </template>
      <vs-sidebar-item id="home">
        <template #icon>
          <i class='bx bx-home'></i>
        </template>
        Inicio
      </vs-sidebar-item>
      <vs-sidebar-item id="subscription">
        <template #icon>
          <i class='bx bxs-crown'></i>
        </template>
        Suscripción
      </vs-sidebar-item>
      <vs-sidebar-item id="linkings">
        <template #icon>
          <i class='bx bx-link-alt'></i>
        </template>
        Conexiones
      </vs-sidebar-item>
      <vs-sidebar-item id="options">
        <template #icon>
          <i class='bx bxs-chip'></i>
        </template>
        Opciones
      </vs-sidebar-item>
      <template #footer>
        <vs-row justify="space-between">
          <vs-avatar>
            <img :src="$store.state.auth.avatarURL" alt="">
            <!-- <img :src="`https://cravatar.eu/helmavatar/${$store.state.auth.username}`" alt=""> -->
          </vs-avatar>
          <!-- <vs-tooltip>
            <vs-avatar badge-color="danger" badge-position="top-right">
              <i class='bx bx-bell' ></i>
              <template #badge>
                28
              </template>
            </vs-avatar>
            <template #tooltip>
              Tienes 28 notificaciones
            </template>
          </vs-tooltip> -->
        </vs-row>
      </template>
    </vs-sidebar>
  </div>
</template>

<script>
import { loadScript } from "@paypal/paypal-js";
import axios from "axios";
import NavBar from "../components/NavBar";

export default {
  name: "MyAccount",
  components: {NavBar},
  data() {
    return {
      sidebar: {
        activeSidebar: false,
        active: 'home',
      },
      options: {
        realname: '',
        username: '',
        email: "",
        avatarType: "gravatar",
        gender: "attack_helicopter",
        publicProfile: false
      },
      isLoggedIn: false,
      account: {
        token: '',
        username: '',
        verifiedEmail: true,
      }
    }
  },
  async beforeMount() {
    this.isLoggedIn = this.$store.state.auth.isLoggedIn;

    if (this.$store.state.auth.isLoggedIn) {
      this.account.token = this.$store.state.auth.token;
      this.account.username = this.$store.state.auth.username;
    }
  },
  async created() {
    if (this.$store.state.auth.isLoggedIn) {
      this.options.realname = this.$store.state.auth.username;
    }
    await axios
        .post(`https://api.videnti.co/user/getMyInfo`, new URLSearchParams(), { headers: { "Content-Type": 'application/x-www-form-urlencoded', 'Authorization': 'Bearer ' + this.$store.state.auth.token, } })
        .then(response => {
          if (response.data.error) { this.checkIfJWTExpired(response.data.message); }
          console.log(response.data);
          this.options.username = response.data.username;
          this.options.email = response.data.email;
          this.options.avatarType = response.data.avatarType.toLowerCase();
          this.account.verifiedEmail = response.data.verifiedEmail;
          this.options.publicProfile = response.data.publicProfile;
        });
  },
  methods: {
    async loadPayPalButton() {
      if (this.sidebar.active !== "subscription") { return; }
      loadScript({ "client-id": "Af7-BsyuXUUobL7rDcoMSrJfPAGcC355jXumTY-fjBIQbkMbhz3EimQFevAx32RtIc23R6SdH8FCPGO8", "vault": true, "intent": "subscription" })
          .then((paypal) => {
            paypal
                .Buttons({
                  style: {
                    shape: 'pill',
                    color: 'gold',
                    layout: 'vertical',
                    label: 'subscribe'
                  },
                  createSubscription: function (data, actions) {
                    return actions.subscription.create({
                      /* Creates the subscription */
                      plan_id: 'P-5P328802408453259MHQPICA'
                    });
                  },
                  // eslint-disable-next-line no-unused-vars
                  onApprove: function (data, actions) {
                    // alert(data.subscriptionID);
                    this.sendPayment(data.subscriptionID);
                  }
                })
                .render("#container-paypal")
                .catch((error) => {
                  console.error("Ocurrió un error al crear el botón de PayPal", error);
                });
          })
          .catch((error) => {
            console.error("Failed to load the PayPal JS SDK script", error);
          });
    },
    async sendPayment(subscriptionId) {
      const params = new URLSearchParams();
      params.append('service', 'paypal');
      params.append('type', 'membership');
      params.append('reference1', subscriptionId);
      params.append('reference2', this.$store.state.auth.username);

      await axios
          .post(`https://api.videnti.co/payment/submit`, params, { headers: { "Content-Type": 'application/x-www-form-urlencoded', 'Authorization': 'Bearer ' + this.$store.state.auth.token, } })
          .then(res => {
            if (res.data.error === true) {
              this.$vs.notification({
                progress: 'auto',
                color: "danger",
                duration: "none",
                title: 'Ocurrió un error',
                text: `${res.data.message}`
              })
            } else {
              this.$vs.notification({
                progress: 'auto',
                color: "success",
                duration: "none",
                title: 'Información',
                text: `${res.data.message}`
              })
            }
          });
    },
    saveChanges() {
      this.$vs.notification({
        progress: 'auto',
        color: "danger",
        duration: "5000",
        title: 'Lo sentimos',
        text: `Este botón de guardar en realidad no hace nada, jaja salu2.`
      })
    }
  }
}
</script>

<style scoped>
.aBitOfMargin {
  margin-top: 134px;
  margin-bottom: 2rem;
}

.user-option {
  margin-top: 1rem;
}

/* .user-option:last-child {
  margin-top: 0;
} */

.radio-left {
  justify-content: left;
}
</style>
